<template>
	<div class="c-loader-graphic">
		<LensFlare
			:id="`c-loader-graphic-flare-${_uid}`"
			class="w-full h-full"
			style="max-width: 260px; max-height: 260px"
			:angle="45"
			:min-blur-amount="25"
			:max-blur-amount="25"
			:flares="[
				{
					size: 480,
					offset: 0,
					opacity: 1,
					theme: 'primary',
					classes: ['c-loader-graphic__flare-first'],
				},
				{
					size: 360,
					offset: -160,
					opacity: 0.7,
					theme: 'secondary',
					classes: ['c-loader-graphic__flare-second'],
				},
				{
					size: 280,
					offset: 60,
					opacity: 0.7,
					theme: 'secondary',
					classes: ['c-loader-graphic__flare-third'],
				},
				{
					size: 160,
					offset: 200,
					opacity: 0.6,
					theme: 'secondary',
					classes: ['c-loader-graphic__flare-fourth'],
				},
			]"
		/>
	</div>
</template>
<script>
import LensFlare from '~/components/shared/LensFlare';

export default {
	name: 'LoaderGraphic',

	components: {
		LensFlare,
	},
};
</script>

<style lang="postcss">
.c-loader-graphic {
	@apply flex justify-center items-center isolate;

	& > {
		@apply z-10;
	}
}
.c-loader-graphic__flare-first {
	transform-origin: 50% 50%;
	animation: loaderGraphicFlare1 2000ms ease-in-out infinite;
}
.c-loader-graphic__flare-second {
	transform-origin: 50% 50%;
	animation: loaderGraphicFlare2 2000ms ease-in-out infinite;
}
.c-loader-graphic__flare-third {
	transform-origin: 50% 50%;
	animation: loaderGraphicFlare3 2000ms ease-in-out infinite;
}
.c-loader-graphic__flare-fourth {
	transform-origin: 50% 50%;
	animation: loaderGraphicFlare4 2000ms ease-in-out infinite;
}

@keyframes loaderGraphicFlare1 {
	50% {
		transform: scale(1.2);
		opacity: 0.8;
	}
}
@keyframes loaderGraphicFlare2 {
	50% {
		transform: translateX(-240px);
		opacity: 0.8;
	}
}
@keyframes loaderGraphicFlare3 {
	50% {
		transform: translateX(180px);
		opacity: 0.8;
	}
}
@keyframes loaderGraphicFlare4 {
	50% {
		transform: translateX(320px);
		opacity: 0.9;
	}
}

@media (prefers-reduced-motion) {
	.c-loader-graphic__flare-first,
	.c-loader-graphic__flare-second,
	.c-loader-graphic__flare-third,
	.c-loader-graphic__flare-fourth {
		animation: unset;
	}
}
.reduced-motion {
	.c-loader-graphic__flare-first,
	.c-loader-graphic__flare-second,
	.c-loader-graphic__flare-third,
	.c-loader-graphic__flare-fourth {
		animation: unset;
	}
}
</style>
